import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import MDBox from "components/MDBox"; // adjust path if different
import { useTranslation } from "react-i18next";
import MDButton from "components/MDButton";
import ScenarioPage from "../scenarioPage";
import ManpowerAnalysisPage from "../../myTeam/Analysis";
import { useLocation } from "react-router-dom";
import LoadingScreen from "components/Loading";
import { getScenarioOrgChartData } from "services/api";
import { buttonStyles } from "services/utils";
import { ReactFlowProvider } from "reactflow";
import GaharPhase1Page from "../gahar";

const ScenarioPageContainer = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(0);
  const location = useLocation();
  const scenarioFromNav = location.state?.scenario;
  const [scenario, setScenario] = useState(scenarioFromNav || {});
  const [loading, setLoading] = useState(false);
  // const [jobs, setJobs] = useState([]);
  const [scenarioJobs, setScenarioJobs] = useState([]);
  // const [revenueGeneratorsSim, setRevenueGeneratorsSim] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

  useEffect(() => {
    const fetchJobs = async () => {
      if (scenario?.id) {
        setLoading(true);
        const scenarioOrgChart = await getScenarioOrgChartData(scenario.id);
        if (scenarioOrgChart !== "error") {
          // Sort by ID (numerical)
          const sortedOrgData = [...scenarioOrgChart].sort((a, b) => a.id - b.id);

          // Replace 'setOrgChartData' with your actual state setter function
          setScenarioJobs(sortedOrgData);
        }
        setLoading(false);
      }
    };

    fetchJobs();
  }, [scenario?.id, refreshKey]);

  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <MDBox>
      <ReactFlowProvider>
        <MDBox mb={2}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems="center">
            <MDButton
              sx={{ ...buttonStyles(view === 0), width: { xs: "100%", sm: "auto" } }}
              variant={view === 0 ? "contained" : "outlined"}
              onClick={() => setView(0)}
            >
              {t("analysis.workload")}
            </MDButton>
            <MDButton
              sx={{ ...buttonStyles(view === 1), width: { xs: "100%", sm: "auto" } }}
              variant={view === 1 ? "contained" : "outlined"}
              onClick={() => setView(1)}
            >
              {t("analysis.manpower")}
            </MDButton>
          </Stack>
        </MDBox>

        {view === 0 ? (
          // CHECK IF IT IS GAHAR
          scenario?.type === "GAHAR Phase 1" ? (
            <GaharPhase1Page jobs={scenarioJobs} scenario={scenario} setJobs={setScenarioJobs} />
          ) : (
            // STANDARD ORG CHART PAGE
            <ScenarioPage
              jobs={scenarioJobs}
              setJobs={setScenarioJobs}
              scenario={scenario}
              setScenario={setScenario}
              triggerParentRefresh={triggerRefresh}
            />
          )
        ) : (
          <ManpowerAnalysisPage scenarioJobs={scenarioJobs} scenario={scenario} />
        )}
      </ReactFlowProvider>
    </MDBox>
  );
};

export default ScenarioPageContainer;
